module.exports = __webpack_public_path__ + "static/media/list_with_three_nodes.d9caa882.png";